import axios from 'axios'
import Config from '../Helpers/Config'

export const findProduct = (productId) => {
    return function (dispatch,getState) {
        dispatch({
            type: 'FETCHING_FIND_PRODUCT'
        });
        return axios.get(Config.api(`product/find/${getState().auth.business.id}/${productId}`),{
            withCredentials:Config.withCredentials()
        })
            .then((response) => {
                if (response.status === 200) {
                    dispatch({
                        type: 'FETCH_FIND_PRODUCT',
                        results: response.data
                    });
                }
            }).catch((error) => {

                console.log(error);
                dispatch({
                    type: 'FETCHING_FIND_PRODUCT_FAILED'
                });
            });
    };
};

export const resetFetchedProduct = () => {
    return function (dispatch) {
        dispatch({
            type: 'RESET_FETCHED_PRODUCT'
        });
    }
}